export const localhost = "localokrs.com";

export function isLocalhost(host: string): boolean {
  return host.indexOf(localhost) === 0;
}

export function isSecure(protocol: string): boolean {
  return protocol === "https:";
}
